// extracted by mini-css-extract-plugin
module.exports = {"section":"SplitSection_section__GugBi","left-content":"SplitSection_left-content__7FV_d","right-content":"SplitSection_right-content__xyZ69"};